module.exports = __webpack_public_path__ + "static/img/play_btn@2x.0bba1e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_btn@2x.png
// module id = MhR+
// module chunks = 1